import { IRepoErrors } from "../../errors";
import { http } from "../../http";

export class UpdateMenuImageError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: UpdateMenuImage");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

export async function uploadMenuImage(
  businessId: string,
  menuId: string,
  file: File
): Promise<string> {
  const data = new FormData();
  data.append("image", file);

  try {
    const response = await http.post(
      `/api/v3/businesses/${businessId}/menus/${menuId}/upload-image`,
      data
    );

    return response.data.image_url;
  } catch (e: any) {
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    throw new UpdateMenuImageError(e);
  }
}
